import { computed, onScopeDispose, watch, type Ref } from 'vue'
import { getRecentSwapsController } from './controller'
import type { RecentSwap } from './contracts'

export const useRecentSwapContinuation = (
  walletAddress: Ref<string | undefined>,
  visible: Ref<boolean>
) => {
  const controller = getRecentSwapsController()
  const release = controller.commands.subscribeContinuation(
    () => ({ walletAddress: walletAddress.value, visible: visible.value }),
    (notify) => watch([walletAddress, visible], notify)
  )
  onScopeDispose(release)
  return {
    continuationStates: computed(() => controller.selectors.continuationStates.value),
    resume: (swap: RecentSwap) => controller.commands.resume(swap, walletAddress.value),
  }
}

export type { RecentSwapContinuationStates } from './contracts'
